<template>
  <div>
    <b-modal
      :no-close-on-backdrop="true"
      id="modal-delete"
      title="Delete User"
      ok-only
      ok-title="Delete"
      @ok="deleteItem"
    >
      <b-card-text>
        <h5>{{ $t("common.delete-sure") }}</h5>
        {{ $t("common.sure-click") }}
      </b-card-text>
    </b-modal>
    <b-modal
      :no-close-on-backdrop="true"
      id="modal-edit"
      ok-only
      centered
      size="lg"
      :title="
        createMode
          ? `${$t('common.add')} ${$t('lab.device')}`
          : `${$t('common.edit')} ${$t('lab.device')}`
      "
    >
      <b-card-text>
        <b-row>
          <b-col md="6">
            <b-form-group :label="$t('common.name')" label-for="name">
              <b-form-input
                v-model="EditForm.name"
                :placeholder="$t('common.name')"
              />
              <p class="text-danger mt-1">{{ errorForm.name }}</p>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group :label="$t('lab.brand')" label-for="brand">
              <b-form-input
                v-model="EditForm.brand"
                :placeholder="$t('lab.brand')"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group :label="$t('lab.model_name')" label-for="model_name">
              <b-form-input
                v-model="EditForm.model_name"
                :placeholder="$t('lab.model_name')"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group :label="$t('lab.type')" label-for="type">
              <b-form-input
                v-model="EditForm.type"
                :placeholder="$t('lab.type')"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
      <template #modal-footer="{}">
        <b-button
          variant="primary"
          @click="submitItem"
          class="m-0"
          :disabled="loading"
          ref="button"
          block
        >
          <span v-if="!loading">{{ $t('common.add') }}</span>
          <b-spinner small v-else></b-spinner>
        </b-button>
      </template>
    </b-modal>
    <b-card :title="$t('lab.test-devices')">
      <div>
        <b-row>
          <b-col cols="12" md="12">
            <h2>{{ $t("common.filter") }} {{ $t("lab.test-devices") }}</h2>
            <br />
          </b-col>

          <b-col md="6" cols="12" class="d-flex align-items-center">
            <b-form-group :label="$t('common.name')" label-for="Name">
              <b-form-input
                id="Name"
                v-model="testName"
                :placeholder="$t('common.name')"
              />
            </b-form-group>
            <div class="mx-3">
              <b-button variant="primary" @click="getTestList()">
                {{ $t("common.search") }}
                <b-icon-search class="ml-1"></b-icon-search>
              </b-button>
            </div>
          </b-col>
        </b-row>
        <!-- Data Table  -->
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2>{{ $t("common.table") }} {{ $t("lab.test-devices") }}</h2>
          <b-button
            v-if="$store.state.app.permissions.includes('store-test')"
            variant="primary"
            @click="show(EditForm, 'create')"
          >
            {{ $t("common.create") }} {{ $t("lab.test-devices") }}
          </b-button>
        </div>

        <b-table
          :items="this.data"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
          v-if="!loading"
        >
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <ActionsButtons
              deletePerm="delete-test"
              editPerm="update-test"
              @editToggle="show(data.item)"
              @deleteToggle="deleteModel(data.item)"
            />
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner label="Loading..." />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >{{ $t("common.showing") }} 1 {{ $t("common.to") }} 10
                {{ $t("lab.test-devices") }}</span
              >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getTestList()"
            >
              <b-pagination
                v-model="page"
                :total-rows="this.dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import permissionChecker from "@/mixins/permissionChecker";
import ActionsButtons from "@/components/common/ActionsButtons.vue";

export default {
  mixins: [permissionChecker],
  components: {
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    VuePhoneNumberInput,
    ActionsButtons,
  },
  data() {
    return {
      take: 10,
      loading: true,
      isNotValid: false,
      dataCount: 0,
      data: [],
      EditForm: {
        name: "",
        price: "",
        normalRange: 0,
        _method: "PUT",
      },
      createMode: false,
      errorForm: {
        name: "",
        price: "",
      },
      params: {
        form: {},
        path: "",
      },
      tableColumns: [
        { key: "name", label: this.$t("common.name"), sortable: true },
        {
          key: "brand",
          label: this.$t("lab.brand"),
          sortable: true,
        },
        {
          key: "model_name",
          label: this.$t("lab.model_name"),
          sortable: true,
        },
        { key: "type", label: this.$t("lab.type") },
        { key: "Actions", label: this.$t("common.actions") },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      page: 1,
    };
  },
  mounted() {
    this.getTestList();
  },
  methods: {
    show(item, mode) {
      if (mode === "create") {
        this.createMode = true;
        this.EditForm = {
          name: "",
          price: "",
          normalRange: 0,

          _method: "POST",
        };
      } else {
        this.createMode = false;

        this.EditForm.id = item.id;
        this.EditForm.name = item.name;
        this.EditForm.price = item.price;
        this.EditForm.normalRange = item.normalRange;

        this.EditForm._method = "PUT";
      }
      this.$bvModal.show("modal-edit");
    },
    showPhoneObj(obj, countryCallingCodeCheck) {
      this.isNotValid = !obj.isValid;
      countryCallingCodeCheck
        ? (this.countryCallingCodeFirst = obj.countryCallingCode)
        : (this.countryCallingCodeSecond = obj.countryCallingCode);
    },
    async getTestList() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/testDevices?page=${this.page}&take=${this.take}&sort=-id`;

      if (this.testName) {
        url += `&filter[name]=${this.testName}`;
      }
      if (this.priceFilter) {
        url += `&filter[price]=${this.priceFilter}`;
      }

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.loading = false;
    },

    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-delete");
    },
    deleteItem() {
      this.$store
        .dispatch("delete", `/testDevices/${this.deleteForm.id}`)
        .then((response) => {
          this.getTestList();

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text: "deleted " + this.deleteForm.first_name + " successfully",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: "Error deleting " + this.deleteForm.first_name,
            },
          });
        });
    },
    submitItem() {
      this.loading = true;
      let count = 0;
      this.errorForm.name = "";
      for (let item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.EditForm[item] == "" || this.EditForm[item] == null)
          delete this.EditForm[item];
      }

      if (!this.EditForm.name) {
        count++;
        this.errorForm.name = "The name field is required.";
      }

      if (count > 0) {
        this.loading = false;
        return false;
      }

      if (this.createMode) {
        (this.params.form = this.EditForm),
          (this.params.path = `/testDevices`),
          this.$store
            .dispatch("create", this.params)
            .then((response) => {
              this.getTestList();
              this.loading = false;
              this.$bvModal.hide("modal-edit");
            })
            .catch((error) => {
              this.loading = false;
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        (this.params.form = this.EditForm),
          (this.params.path = `/testDevices/${this.EditForm.id}`),
          this.$store
            .dispatch("update", this.params)
            .then((response) => {
              this.getTestList();
              this.loading = false;
              this.$bvModal.hide("modal-edit");
            })
            .catch((error) => {
              this.loading = false;
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
